import { tr } from 'mmfintech-commons'
import LogoImage from '@images/icons/kingdom-bank-logo.svg'
import settings from '@settings'
import cn from 'classnames'
import { isValidString } from 'mmfintech-commons'
import styles from './KingdomBankLogo.module.scss'

export const KingdomBankLogo = ({ autoWidth = false, url = '' }) => (
  <div className={cn(styles['logo-wrapper'], 'logo-wrapper', { 'auto-width': autoWidth })}>
    <a href={isValidString(url) ? url : settings.landingPageUrl}>
      <img src={LogoImage} alt={tr('FRONTEND.KINGDOM_BANK_LOGO.LOGO', 'Logo')} />
    </a>
  </div>
)
